// src/pages/login.jsx
import React, { useEffect, useState } from 'react';
import { motion } from "framer-motion";
import { Link, useNavigate, ScrollRestoration } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { setUser } from '../store/user/userSlice';

import axiosInstance from '../utils/axiosInstance';

import { slideUp } from '../utils/slideUp';
import PageTitle from '../components/common/pageTitle';
import GoogleSignInButton from '../components/auth/GoogleSignInButton';


const Login = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // User data from Redux store
  const userData = useSelector((state) => state.user);


  // Load remembered email
  const [email, setEmail] = useState(localStorage.getItem('rememberedEmail') || '');
  const [password, setPassword] = useState('');
  // Initialize based on remembered email
  const [rememberMe, setRememberMe] = useState(!!localStorage.getItem('rememberedEmail'));
  const [error, setError] = useState('');


  // Redirect to home if the user is already logged in
  useEffect(() => {
    if (userData.email) { navigate('/'); }
  }, [userData.email, navigate]);



  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    // Send login request to backend
    try {

      const { data } = await axiosInstance.post('/api/auth/login', { email, password });
      const { name, email: userEmail, profilePic, points, token } = data;

      // Store token in localStorage
      localStorage.setItem('token', token);

      // Save email if '記住帳號' is checked
      if (rememberMe) {
        localStorage.setItem('rememberedEmail', email);
      } else {
        localStorage.removeItem('rememberedEmail');
      }

      // Dispatch setUser to store user data in Redux
      dispatch(setUser({ name, email: userEmail, profilePic, points, token }));

      navigate('/dashboard'); // Or wherever you want to redirect after login
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || 'Login failed');
    }
  };


  const handleGoogleLoginSuccess = async (idToken) => {
    try {
      const { data } = await axiosInstance.post('/api/auth/google', { idToken });
      const { name, email, profilePic, points, token } = data;

      // After Google login success
      localStorage.setItem('token', data.token);

       // Dispatch setUser with the data from Google login
      dispatch(setUser({ name, email, profilePic, points, token }));

      navigate('/dashboard');
    } catch (error) {
      console.error(error);
      setError(err.response?.data?.error || 'Google login failed. Please try again.');
    }
  };



  return (
    <>

      <PageTitle link={"帳號登入"} pageName={"帳號登入"} />

      <div className="login-area ptb-100">
        <div className="container">

          <motion.div className="login-info"
            initial="offscreen"
            whileInView="onscreen"
            variants={slideUp(1)}
            viewport={{ once: true, amount: 0 }}
          >
            <div style={{ margin:'20px 0px 40px 0px' }}>
              <h2>登入 DraftLegal AI</h2>
            </div>

            {/* 帳號密碼登入 */}
            <form onSubmit={handleSubmit}>
              {error && <div className="alert alert-danger">{error}</div>}

              {/* 帳號 */}
              <div className="form-group">
                <input 
                  type="email" 
                  className="form-control" 
                  placeholder="Email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required 
                />
              </div>

              {/* 密碼 */}
              <div className="form-group">
                <input 
                  type="password" 
                  className="form-control" 
                  placeholder="Your password" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              {/* 記住帳號 */}
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="flexCheckDefault"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  記住帳號
                </label>
              </div>

              {/* 登入 */}
              <div style={{ display: 'flex', justifyContent: 'center', margin:'30px 0px 50px 0px' }}>
                <button className="default-btn border-0" style={{ maxWidth: '70%', margin:'0' }} type="submit">
                  <i className="ri-arrow-right-line"></i>
                  登入
                </button>
              </div>

              {/* 註冊 */}
              <div>
                <p>還沒有帳號嗎？<Link to="/register">註冊帳號</Link></p>
              </div>

            </form>

            <hr />
            
            {/* Google 帳號登入 */}
            <div>
              <p>使用 Google 帳號登入：</p>
              <div style={{ display:'flex', justifyContent:'center' }}>
                <GoogleSignInButton onSuccess={ handleGoogleLoginSuccess } />
              </div>
            </div>

          </motion.div>
        </div>
      </div>

      <ScrollRestoration />

    </>
  );
};

export default Login;



